import { tw } from '@/utils/tw';

const LineBreak = tw.theme({});

export default LineBreak;
